import { render, staticRenderFns } from "./PackageCreate.vue?vue&type=template&id=51bf431a&scoped=true&"
import script from "./PackageCreate.vue?vue&type=script&lang=js&"
export * from "./PackageCreate.vue?vue&type=script&lang=js&"
import style0 from "./PackageCreate.vue?vue&type=style&index=0&id=51bf431a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf431a",
  null
  
)

export default component.exports